// removed by extract-text-webpack-plugin
module.exports = {"row":"_3K2DgMHg6h6qPtz-OhTcEU","iconAddress":"_-m4C4ZSxWEEh2sHvAbIlM","iconRadio":"KJ2oq_3FDcIW5myGLcG0N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/ShopItem.scss
// module id = 1113
// module chunks = 0